module.exports = __webpack_public_path__ + "static/media/Ki.8f9a1a6c.woff";